import { isBrowser } from './detection';

/**
 * A safe wrapper for browser sessionStorage that checks for window availability.
 *
 * These methods guard against usage in non-browser environments (e.g. during SSR in Next.js),
 * avoiding runtime errors by validating that `window` and `sessionStorage` exist.
 */
export const SessionStorage = {
  /**
   * Stores a value in sessionStorage under the specified key.
   *
   * @param key - The sessionStorage key to set.
   * @param value - The value to store. It will be stringifies.
   */
  setItem(key: string, value: unknown): void {
    if (isBrowser()) {
      window.sessionStorage.setItem(key, (value as string).toString());
    }
  },

  /**
   * Retrieves a value from sessionStorage by key.
   *
   * @param key - The sessionStorage key to retrieve.
   * @returns The stored value as a string, or `null` if not found or not in a browser context.
   */
  getItem(key: string): string | null {
    if (!isBrowser()) return null;

    return window.sessionStorage.getItem(key);
  },

  /**
   * Removes a key-value pair from sessionStorage.
   *
   * @param key - The sessionStorage key to remove.
   */
  removeItem(key: string): void {
    if (isBrowser()) {
      window.sessionStorage.removeItem(key);
    }
  },
};
